import qs, { IStringifyOptions } from 'qs';

export function hashParamsParse<Q extends Record<string, any>>(
  query?: string | URLSearchParams | null,
  options: qs.IParseOptions = {},
): Q {
  if (!query) {
    // @ts-ignore
    return {};
  }

  let actualQuery: string;
  if (typeof query === 'string') {
    if (query[0] === '#') {
      actualQuery = query.slice(1);
    } else {
      actualQuery = query;
    }
  } else {
    actualQuery = query.toString();
  }

  return qs.parse(actualQuery, {
    // @ts-ignore
    arrayFormat: 'brackets',
    skipNulls: true,
    delimiter: ';',
    ...options,
  }) as Q;
}

/**
 * Returns a hash params string prepended by a "?"
 */
export function hashParamsStringify<T extends Record<string, any>>(
  query?: T | null,
  options: qs.IStringifyOptions = {},
) {
  if (!query) {
    return '';
  }

  return (
    '#' +
    qs.stringify(query, {
      addQueryPrefix: false,
      arrayFormat: 'brackets',
      skipNulls: true,
      ...options,
    })
  );
}

/**
 * Takes strings or objects to return a combined hash params string
 */
export function hashParamsUpdateString(
  input: (string | null | undefined | Record<string, any> | URLSearchParams)[],
  options?: IStringifyOptions,
): string {
  const combined = input.reduce<Record<string, any>>((prev, cur) => {
    if (typeof cur === 'string') {
      return {
        ...prev,
        ...hashParamsParse(cur),
      };
    } else {
      return {
        ...prev,
        ...cur,
      };
    }
  }, {});

  return hashParamsStringify(combined, options);
}
